module.exports = __webpack_public_path__ + "assets/img/NPC007.0a3ab701.png";